import React from "react"
import 'whatwg-fetch';
import App from "./app";
import { createStore, applyMiddleware } from "redux";
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { Provider } from 'react-redux';
import allReducers from './reducers';
import {apiMiddleware, isRSAA, RSAA} from 'redux-api-middleware/es';
import {history} from "./utils/history";
import {routerMiddleware, ConnectedRouter} from "connected-react-router";
import {apiUnauthorizedWrapper, authApiWrapper, authInit} from "../../common/js/auth/auth-utils";
import {library} from '@fortawesome/fontawesome-svg-core';
import {far} from '@fortawesome/pro-regular-svg-icons';
import {fal} from '@fortawesome/pro-light-svg-icons';
import {fas} from '@fortawesome/free-solid-svg-icons';
import {initUtils} from "../../common/js/utils";
import createSagaMiddleware from "redux-saga";
import {authWatcher, candidateRootSaga, langWatcher} from "./sagas/constants-saga";
import {langApiWrapper} from "../../common/js/lang/lang-utils";

initUtils();

library.add(far);
library.add(fas);
library.add(fal);

const historyMiddleware = routerMiddleware(history);
const sagaMiddleware = createSagaMiddleware();

let middleware = [
    historyMiddleware,
    langApiWrapper,
    authApiWrapper,
    apiUnauthorizedWrapper,
    apiMiddleware,
    thunk,
    promise,
    sagaMiddleware
];

if (process.env.NODE_ENV !== 'production') {
    middleware = [ ...middleware, createLogger() ]
}

const store = createStore(allReducers, applyMiddleware(...middleware));

authInit(store);
sagaMiddleware.run(candidateRootSaga);

class Main extends React.Component {
    render () {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <App/>
                </ConnectedRouter>
            </Provider>
        );
    }
}

Main.propTypes = {};

export default Main;
